import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './styles.css';
import { ThemeProvider } from './contexts/ThemeContext';
import { BanNotificationProvider } from './ui/BanNotification';
import { AppLayout } from './ui/AppLayout';
import { HomePage } from './pages/HomePage';
import { CalendarPage } from './pages/CalendarPage';
import { GalleryPage } from './pages/GalleryPage';
import { GalleryPostPage } from './pages/GalleryPostPage';
import { AnnouncementsPage } from './pages/AnnouncementsPage';
import { AnnouncementPage } from './pages/AnnouncementPage';
import { AdminLoginPage } from './pages/admin/AdminLoginPage';
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'takvim', element: <CalendarPage /> },
      { path: 'galeri', element: <GalleryPage /> },
      { path: 'galeri/:slug', element: <GalleryPostPage /> },
      { path: 'duyurular', element: <AnnouncementsPage /> },
      { path: 'duyuru/:slug', element: <AnnouncementPage /> },
    ],
  },
  { path: '/__admin', element: <AdminLoginPage /> },
  { path: '/__admin/panel', element: <AdminDashboardPage /> },
]);

// Hide loading screen when app is ready
function hideLoader() {
  const loader = document.getElementById('app-loader');
  if (loader) {
    loader.classList.add('loaded');
    setTimeout(() => loader.remove(), 300);
  }
}

const container = document.getElementById('root');
if (!container) throw new Error('Root bulunamadı');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <BanNotificationProvider>
          <RouterProvider router={router} />
        </BanNotificationProvider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// Hide loader after React renders
hideLoader();
